(function () {
  'use strict';

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-auto-submit]')) {
      e.target.closest('form').requestSubmit();
      return;
    }
    if (e.target.closest('#FacetFilterForm') && e.target.type === 'checkbox') {
      e.target.closest('form').requestSubmit();
    }
  });
})();
